import headNav from '@src/components/head_nav'
import inviteCodeRule from '../components/inviteCodeRule'
import inviteIcon from "../images/inviteIcon.webp"
import inviteIcon_block from "../images/inviteIcon_block.webp"
import awardDialog from '@src/components/awardDialog'
import util from "@src/utils/util.js"
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
import { bindInviteCode } from './services'
import clear from "../images/clear.webp"
import clear_dark from "../images/clear_dark.webp"

let vm = {
  components: {
    headNav,
    awardDialog,
    inviteCodeRule
  },
  data() {
    return {
      clear,
      clear_dark,
      isDetail: false,
      showTip: true,
      inviteIcon,
      inviteIcon_block,
      isShowAwardDialog: false,
      userRewardRsp: {},
      isNight: false,
      isActivite: false,
      inputValue: '',
      isInviteCode: false,
      isInputLine: false,
      inputField: '',
      inviteTypeSingin: false,
      errorMessage: '',
      rewardType: '',
      inviteTipDesc: '',
      rewardInvitedNum: 0,
      symbol: ''
    };
  },
  computed: {
    clearUrl() {
      if (this.isNight) {
        return clear_dark
      } else {
        return clear
      }
    },
    inviteUrl() {
      if (this.isNight) {
        return inviteIcon_block
      } else {
        return inviteIcon
      }
    }
  },
  async mounted() {
    this.isNight = util.isNight()
    if (window.loading && window.loading.isPaused) {
      window.loading.play()
    }
    this.setStatusBarFontColor(false)
    let { rewardType, inviteTipDesc, rewardInvitedNum, symbol } = this.$route.query
    this.rewardType = rewardType
    this.inviteTipDesc = inviteTipDesc
    this.rewardInvitedNum = rewardInvitedNum
    this.symbol = symbol
    if (this.rewardType == 1) {
      this.inviteTypeSingin = true
    }
    this.inputValue = this.$refs.input.value
    this.inputField = this.$refs.input
  },
  methods: {
    gotIt() {
      ActStat.reportCustom('closeAwardSuccessDialog')
      this.isShowAwardDialog = false
      JsBridge.openActivity('oap://qg/mine')
    },
    setStatusBarFontColor(isWhiteFont) {
      if (JsBridge.getEnv() === 'gameHall') {
        window.android.setStatusBarFontColor(isWhiteFont)
      }
    },
    onfocusEvent() {
      this.isActivite = true
    },
    onblurEvent() {
      if (this.inputValue) return
      this.isActivite = false
    },
    clearEvent() {
      this.inputValue = ""
      this.isInputLine = false
      this.isInviteCode = false
      this.inputField.focus()
    },
    oninputEvent() {
      this.isInputLine = false
      this.isInviteCode = false
    },
    errorEvent() {
      this.inputField.classList.add('input');
      let that = this
      setTimeout(function () {
        that.inputField.classList.remove('input')
      }, 1000);
      this.isInviteCode = true
      this.isInputLine = true
      this.inputField.setSelectionRange(0, this.inputField.value.length)
      this.inputField.focus()
    },
    submitEvent() {
      if (this.inputValue) {
        this.bindInviteCode()
      }
    },
    async bindInviteCode() {
      let { activityId } = this.$route.query
      let res = await bindInviteCode({ activityId, inviteCode: this.inputValue })
      console.log("res", res)
      if (res.code === "2000") {
        ActStat.reportCustom('inviteClickSubmitSuccessbutton')
        if (this.rewardType == 1) {
          JsBridge.makeToast(this.$t('inviteCode.submitSucccess'))
          setTimeout(function () {
            JsBridge.openActivity('oap://qg/mine')
          }, 2000);
        }
        if (this.rewardType == 2) {
          ActStat.reportCustom('inviteAwardSuccessDialog')
          this.isShowAwardDialog = true
          this.inputField.blur()
        }
      } else {
        ActStat.reportCustom('inviteClickSubmitFailbutton')
        if (res.code === "5607") {
          this.errorEvent()
          this.errorMessage = this.$t('inviteCode.inviteCodeError')
        }
        if (res.code === "5608") {
          this.errorEvent()
          this.errorMessage = this.$t('inviteCode.inviteCodeRegion')
        }
        if (res.code === "5609") {
          this.errorEvent()
          this.errorMessage = this.$t('inviteCode.phoneSame')
        }
      }
    },
  }
};

export default vm;



// WEBPACK FOOTER //
// ./src/pages/inviteCodePage/scripts/index.js